export default {
  header: {
    navigation: {
      about: "About us",
      resources: "Resources",
      directory: "RGE Artisans Directory",
    },
    menu: "Menu",
  },
  home: {
    hero: {
      title1: "Become an Ambassador at",
      title2: "projetsolaire.",
      subtitle: "Join the Solar Revolution and Earn at the Same Time!",
      button: "Start",
      "learn-more": "Learn more",
      badge: "Let's accelerate the solar revolution, together.",
      "badge-link": "Learn more about us",
      "current-title": "Refer. Earn 500 €.<br/>Save the planet.",
      "current-description":
        "Get paid for sharing the benefits of solar energy with your neighbors, loved ones and colleagues. And help us change the world.",
      label: "Let's accelerate the solar revolution together.",
      "button-label": "Become an ambassador",
      "image-alt": "Ambassador program hero image",
    },
    why: {
      whyup: "Why?",
      title: "Why become a solar energy ambassador?",
      reason1: {
        title: "Environmental Impact:",
        description:
          "Contribute to the fight against climate change by promoting a clean and renewable energy source.",
      },
      reason2: {
        title: "Additional Income:",
        description:
          "Earn money by recommending our services and helping homeowners switch to solar energy.",
      },
      reason3: {
        title: "Training and Support:",
        description:
          "Benefit from comprehensive training and ongoing support to succeed as an ambassador.",
      },
      reason4: {
        title: "Flexibility:",
        description:
          "Work at your own pace, wherever you want, according to your schedule and lifestyle.",
      },
      caption:
        '"I have already sponsored two friends and was able to accompany them on their journey to self-consumption. Their installations went smoothly, they are delighted. Everyone wins!"',
    },
    benefits: {
      title: "Why Spread the Word About Solar?",
      description:
        "At ProjetSolaire, we've completed thousands of solar projects, and here are some compelling reasons for you to help us spread the word about solar energy.",
      items: {
        nothing: {
          title: "Nothing to do",
          description:
            "Our study office conducts the solar and storage study. Once you validate the custom solar project, we conduct a tender to obtain several quotes.",
        },
        scams: {
          title: "Fighting against scams",
          description:
            "We oversee the solar project: we prepare the technical file, organize the mandatory technical visit, and handle administrative, financial, and insurance procedures.",
        },
        climate: {
          title: "Climate impact",
          description:
            "Helping you promote next-generation photovoltaic technology, aesthetic and powerful. The clean solar energy resource will last for decades, reducing pollution.",
        },
      },
      cta: "Steps to go solar ->",
      testimonial: {
        quote:
          "“I have already referred 8 friends and my mom! Four have taken action, I earned 2 thousand euros!”",
        author: "Jean",
        location: "Aix-en-Provence",
      },
    },
    how: {
      title: "How to do it",
      description:
        "Simple steps that only require an electricity bill to get started.",
      step1: {
        title: "Sign up for free",
        description: "Sign up in 2 minutes to get acquainted. Yes, it's free.",
      },
      step2: {
        title: "Upload an electricity bill",
        description: "Discuss the benefits of solar energy with a homeowner.",
      },
      step3: {
        title: "Share the study and get quotes",
        description:
          "You have nothing to do, except maybe show the study. Receive €500 at installation.",
      },
    },
    tools: {
      title: "Our tools",
      description: "We give you access to tools to make your task easier.",
      tool1: {
        title: "Training:",
        description:
          "Benefit from comprehensive training to launch yourself into the solar adventure with complete peace of mind!",
      },
      tool2: {
        title: "Support:",
        description:
          "You will receive marketing materials to help you achieve your goals.",
      },
    },
    faq: {
      title: "Frequently Asked Questions (FAQ):",
      q1: {
        question: "How does the ambassador program work?",
        respond:
          "Our ambassador program rewards you every time you recommend a client who signs a quote with us. The more you recommend, the more you earn.",
      },
      q2: {
        question: "Are there any costs associated with becoming an ambassador?",
        respond: "No, registration as an ambassador is completely free.",
      },
      q3: {
        question: "Do I need prior knowledge of solar energy?",
        respond:
          "No, we provide comprehensive training to prepare you to promote our services.",
      },
    },
    cta: {
      title: "Become an Ambassador at projetsolaire",
      description:
        "Join our team of ambassadors passionate about electrical self-consumption and transform your passion into profit. As an ambassador, you will have the opportunity to promote electrical independence and help people save on their energy bills while earning money. Be a leader in the movement towards a smarter and more economical energy future.",
      button: "Join the adventure",
    },
    banner: {
      paragraph: "Sponsor today to receive multiple artisan quotes",
      description:
        "It's as simple as that to contribute to eliminating tons of CO2 from the atmosphere. And the more people you sponsor, the more chances you have to receive €500 per sponsorship, paid directly to your bank account.",
      button: "I sponsor!",
    },
  },
  "sign-in": {
    title: "Welcome, help us grow photovoltaics in France!",
  },
  faq: {
    title: "Our answers to your questions about paid word-of-mouth",
  },
}
